const faviconsContext = require.context('.', true, /\.(svg|png|ico|xml)$/);
faviconsContext.keys().forEach(faviconsContext);

require('~/favicons/manifest.json');
